import type { IntlShape } from 'react-intl';

import { XYCHART_MESSAGES } from '../../../messages/messages.js';

const separatorCache = new WeakMap<IntlShape, string>();

/**
 * Resolves the static `separatorDash` message via `intl.formatMessage`
 * the first time it is requested for a given `intl` instance, and
 * returns the cached string on every subsequent call.
 *
 * In shared-tooltip mode this helper is hit O(rows) times per
 * mouse-move render; the underlying `formatMessage` call walks
 * formatjs's `deepMergeFormatsAndSetTimeZone` path, which dominated
 * the recorded profile when invoked uncached.
 */
export function getCachedSeparator(intl: IntlShape): string {
  const cached = separatorCache.get(intl);
  if (cached !== undefined) {
    return cached;
  }
  const resolved = intl.formatMessage(XYCHART_MESSAGES.separatorDash);
  separatorCache.set(intl, resolved);
  return resolved;
}
